import { authApi } from '@/core/api/auth'

export const {
  useGetMagicLinkQuery,
  useGetMyNetworkInvitationsQuery,
  useLazyGetMagicLinkQuery,
  useGetMyNotificationsQuery,
  useMarkNotificationsAsObservedMutation,
  useModifyPasswordMutation,
  useUpdateMyProfileMutation,
} = authApi
